import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  Select,
  Popconfirm,
  notification,
  Spin,
} from "antd";
import { Column } from "@ant-design/charts";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  buildingAssets,
  building,
  faCategory,
  faSubCategory,
} from "../../../constants/url";
import { axiosInstance } from "../../../commons/commons";

class BuildingAssets extends React.Component {
  _isMounted = false;
  state = {
    editIsVisible: true,
    drawerIsVisible: false,
    editFormFields: [],
    faCategoryData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    faSubCategoryData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    drawerBuildingData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    tableData: {
      list: [],
      loading: true,
    },
    visualizationData: [],
  };

  formRef = null;

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
    },
    {
      title: "Building",
      dataIndex: ["Building", "BuildingName"],
      key: "BuildingName",
      align: "center",
      fixed: "left",
      width: 100,
    },
    {
      title: "Code",
      dataIndex: "FACode",
      key: "FACode",
      align: "center",
      width: 100,
    },
    {
      title: "Name",
      dataIndex: "FAName",
      key: "FAName",
      align: "center",
      width: 100,
    },
    {
      title: "Category",
      dataIndex: ["FMFACategory", "UserName"],
      key: "CategoryName",
      align: "center",
      width: 100,
    },
    {
      title: "Sub Category",
      dataIndex: ["FMFASubCategory", "UserName"],
      key: "SubCategoryName",
      align: "center",
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "FADescription",
      key: "FADescription",
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              hidden={!this.state.editIsVisible}
              style={{ color: "#1890ff" }}
              onClick={async () => {
                /**
                 * hide edit button because fetching data from backend might take
                 * a while. so prevent user from multi-clicking the edit button.
                 */
                this.setState({ editIsVisible: false });
                let state = this.state;
                const tempList = [];
                Object.keys(item).map((key) => {
                  tempList.push({ name: key, value: item[key] });
                  return key;
                });
                state.drawerBuildingData.list.map((building, index) => {
                  // select the matching building
                  if (building.BuildingID === item.BuildingID) {
                    tempList.push({
                      name: "BuildingID",
                      value:
                        "buildingDrawer*-" +
                        index +
                        "*-" +
                        building.BuildingName,
                    });
                  }
                  return building;
                });
                for (let cat of state.faCategoryData.list) {
                  if (
                    // select the matching category
                    cat.FACategoryID === item.FACatID
                  ) {
                    state.faCategoryData.selectedIndex =
                      state.faCategoryData.list.indexOf(cat);
                    tempList.push({
                      name: "FACatID",
                      value:
                        "faCategory*-" +
                        state.faCategoryData.selectedIndex +
                        "*-" +
                        cat.FACategoryID,
                    });
                    await axiosInstance
                      .get(
                        faSubCategory +
                          "?FACategoryID=" +
                          state.faCategoryData.list[
                            state.faCategoryData.selectedIndex
                          ].FACategoryID
                      )
                      .then((res) => {
                        if (res.data.success) {
                          state.faSubCategoryData = {
                            list: res.data.message,
                            selectedIndex: null,
                            selectedValue: null,
                          };
                          state.faSubCategoryData.list.map((subCat, index) => {
                            if (
                              // select the matching subCategory
                              subCat.FASubCategoryID === item.FASubCatID
                            ) {
                              tempList.push({
                                name: "FASubCatID",
                                value:
                                  "faSubCategory*-" +
                                  index +
                                  "*-" +
                                  subCat.FASubCategoryID,
                              });
                            }
                            return subCat;
                          });
                        }
                      })
                      .catch(() => {});
                    break;
                  }
                }
                state.editFormFields = tempList;
                state.drawerIsVisible = true;
                state.editIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(buildingAssets + "/" + item.FAID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((state) => {
                      this.resetFields();
                      this.setState(state);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getInitialState = async (drawerIsVisible) => {
    let state = {
      editIsVisible: true,
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      faCategoryData: {
        list: this.state.faCategoryData.list,
        selectedIndex: null,
        selectedValue: null,
      },
      faSubCategoryData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      drawerCompanyData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      drawerBuildingData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      tableData: {
        list: [],
        loading: false,
      },
      visualizationData: [],
    };
    await axiosInstance
      .get(building)
      .then((res) => {
        if (res.data.success) {
          state.drawerBuildingData.list = res.data.message;
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(faCategory)
      .then((res) => {
        if (res.data.success) state.faCategoryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(buildingAssets)
      .then((res) => {
        if (res.data.success) {
          let data = {};
          state.tableData.list = res.data.message.map((asset, index) => {
            asset.SN = index + 1;
            asset.key = index;
            if (asset.Building) {
              if (!data[asset.Building.BuildingName])
                data[asset.Building.BuildingName] = {
                  Value: 1,
                };
              else data[asset.Building.BuildingName].Value += 1;
            }
            return asset;
          });
          state.visualizationData = Object.keys(data).map((buildingName) => ({
            BuildingName: buildingName,
            ...data[buildingName],
          }));
        }
      })
      .catch(() => {});
    return state;
  };

  onChange = (value) => {
    let theIndex = value.split("*-")[1];
    let theValue = value.split("*-")[2];
    switch (value.split("*-")[0]) {
      case "buildingDrawer":
        this.setState({
          drawerBuildingData: {
            list: this.state.drawerBuildingData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
        });
        break;
      case "faCategory":
        this.setState(
          {
            faCategoryData: {
              list: this.state.faCategoryData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
          },
          () => {
            axiosInstance
              .get(
                faSubCategory +
                  "?FACategoryID=" +
                  this.state.faCategoryData.list[
                    this.state.faCategoryData.selectedIndex
                  ].FACategoryID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    faSubCategoryData: {
                      list: res.data.message,
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                else
                  notification.error({
                    message: "Fail",
                    description: res.data.message,
                  });
              })
              .catch(() => {});
          }
        );
        break;
      case "faSubCategory":
        this.setState({
          faSubCategoryData: {
            list: this.state.faSubCategoryData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
        });
        break;
      default:
        break;
    }
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then((values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        (this.state.editFormFields.length
          ? axiosInstance.put(buildingAssets, {
              FAID: values.FAID,
              BuildingID:
                this.state.drawerBuildingData.list[
                  values.BuildingID.split("*-")[1]
                ].BuildingID,
              FACatID:
                this.state.faCategoryData.list[values.FACatID.split("*-")[1]]
                  .FACategoryID,
              FASubCatID:
                this.state.faSubCategoryData.list[
                  values.FASubCatID.split("*-")[1]
                ].FASubCategoryID,
              FAName: values.FAName,
              FACode: values.FACode,
              FADescription: values.FADescription,
              DateEdited: new Date(),
            })
          : axiosInstance.post(buildingAssets, {
              BuildingID:
                this.state.drawerBuildingData.list[
                  values.BuildingID.split("*-")[1]
                ].BuildingID,
              FACatID:
                this.state.faCategoryData.list[values.FACatID.split("*-")[1]]
                  .FACategoryID,
              FASubCatID:
                this.state.faSubCategoryData.list[
                  values.FASubCatID.split("*-")[1]
                ].FASubCategoryID,
              FAName: values.FAName,
              FACode: values.FACode,
              FADescription: values.FADescription,
              DateCreated: new Date(),
            })
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((state) => {
                this.resetFields();
                this.setState(state);
              });
            } else {
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
              this.setState({
                tableData: { list: this.state.tableData.list, loading: false },
              });
            }
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch(() => {});
  };

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };
  onReset = () => {
    this.getInitialState().then((state) => this.setState(state));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((state) =>
      this._isMounted ? this.setState(state) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Building Assets"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
                style={{ borderRadius: 20 }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          >
            <Form.Item
              key="FAID"
              name="FAID"
              label="FAID"
              labelAlign="left"
              labelCol={{ span: 7 }}
              hidden
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="BuildingID"
              name="BuildingID"
              label="Building"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please select a building" }]}
            >
              <Select
                showSearch
                placeholder="Select a Building"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.drawerBuildingData.selectedValue}
              >
                {this.state.drawerBuildingData.list.map((building, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "buildingDrawer*-" +
                        index +
                        "*-" +
                        building.BuildingName
                      }
                    >
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="FAName"
              name="FAName"
              label="Name"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please enter asset name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="FACode"
              name="FACode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: false, message: "Please enter asset code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="FACatID"
              name="FACatID"
              label="Category"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[
                { required: true, message: "Please select asset category" },
              ]}
            >
              <Select
                showSearch
                placeholder="FA Category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.faCategoryData.selectedValue}
              >
                {this.state.faCategoryData.list.map((cat, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"faCategory*-" + index + "*-" + cat.FACategoryID}
                    >
                      {cat.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="FASubCatID"
              name="FASubCatID"
              label="Sub Category"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[
                { required: true, message: "Please select asset subcategory" },
              ]}
            >
              <Select
                showSearch
                placeholder="FA Sub Category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={this.state.faSubCategoryData.selectedValue}
              >
                {this.state.faSubCategoryData.list.map((subcat, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "faSubCategory*-" +
                        index +
                        "*-" +
                        subcat.FASubCategoryID
                      }
                    >
                      {subcat.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="FADescription"
              name="FADescription"
              label="Description"
              labelAlign="left"
              labelCol={{ span: 7 }}
            >
              <Input.TextArea rows={3}></Input.TextArea>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ marginTop: 10, marginBottom: 20 }}>
          <Col span={4} style={{ textAlign: "center" }}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Building Assets</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}></Col>
        </Row>
        <Spin
          spinning={this.state.tableData.loading}
          tip="fetching and populating data..."
        >
          <Row gutter={48} style={{ paddingLeft: 10, paddingRight: 10 }}>
            {this.state.visualizationData.length ? (
              <>
                <Col span={12} xs={24} sm={24} md={8} lg={8}>
                  <Row>
                    <Col
                      span={24}
                      style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        // borderRadius: 20,
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      <Column
                        {...{
                          data: this.state.visualizationData,
                          // isGroup: true,
                          xField: "BuildingName",
                          yField: "Value",
                          // seriesField: "BuildingName",
                          label: {
                            position: "bottom",
                            layout: [
                              {
                                type: "interval-adjust-position",
                              },
                              {
                                type: "interval-hide-overlap",
                              },
                              {
                                type: "adjust-color",
                              },
                            ],
                          },
                          slider: {
                            start: 0,
                            end: 1,
                          },
                          // (innerHeight-headerFooter-viewSearchRow)/2-marginTop-for-Column
                          height: (window.innerHeight - 98 - 50) / 2,
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={0}
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  style={{ marginTop: 10 }}
                ></Col>
              </>
            ) : null}
            <Col
              {...(this.state.visualizationData.length
                ? { span: 12, xs: 24, sm: 24, md: 16, lg: 16 }
                : { span: 24 })}
            >
              <Row
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              >
                <Col span={20}></Col>
                <Col span={4} style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ drawerIsVisible: true });
                    }}
                    style={{ borderRadius: 20 }}
                  >
                    New
                  </Button>
                </Col>
                <Col span={24}>
                  <Table
                    // loading={this.state.tableData.loading}
                    dataSource={this.state.tableData.list}
                    columns={this.columns}
                    scroll={{ y: window.innerHeight - 290 }}
                    pagination={{
                      size: "small",
                      disabled: false,
                      defaultPageSize: 20,
                      showQuickJumper: true,
                      showSizeChanger: true,
                      total: this.state.tableData.list.length,
                    }}
                  ></Table>
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withRouter(BuildingAssets);
